import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { ITongHopToanKhoaRequest } from "../../../model/request/tong-hop-diem/ITongHopToanKhoaRequest";
import { ITongHopDiemResponse } from "../../../model/response/tong-hop-diem/ITongHopDiemResponse";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eTongHopToanKhoaActionsObj = {
    LOAD_START: {} as ITongHopToanKhoaRequest,
    LOAD_SUCCESS: {} as ITongHopDiemResponse,
    LOAD_ERROR: "",
    

    CHANGE_IS_SHOW_DIEM_THANH_PHAN: {} as boolean,
    CHANGE_IS_SHOW_CAC_LAN_DIEM: {} as boolean,

    CHANGED_FOCUSED_VALUE_LOP: {} as ITreeviewLopFocusedValue,
}

export const eTongHopToanKhoaActionIds = generateActionTypeIds(eTongHopToanKhoaActionsObj, "TONG_HOP_TOAN_KHOA");
export type ITongHopToanKhoaActionTypes = IGenericActionType<typeof eTongHopToanKhoaActionsObj, "TONG_HOP_TOAN_KHOA">;